<aside
class="fixed top-0 left-0 z-40 w-72 h-screen pt-14 transition-transform -translate-x-full bg-white border-r border-gray-200 md:translate-x-0"
aria-label="Sidenav"
id="drawer-navigation"
>
<div class="overflow-y-auto py-5 px-3 h-full bg-white">
  <form action="#" method="GET" class="md:hidden mb-2">
    <label for="sidebar-search" class="sr-only">Search</label>
  </form>
  <ul class="space-y-2">
    <li>
      <a
      routerLink="/propose-transaction" [routerLinkActive]="'active-class'"  [routerLinkActiveOptions]="{ exact: true }"
        class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg hover:bg-gray-100 group"
      >
        <svg
          aria-hidden="true"
          class="w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
          <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
        </svg>
        <span class="ml-3">Propose Transaction</span>
      </a>
    </li>
    <li>
        <a
          routerLink="/view-all-transaction" [routerLinkActive]="'active-class'"  [routerLinkActiveOptions]="{ exact: true }"
          class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg hover:bg-gray-100 group"
        >
          <svg
            aria-hidden="true"
            class="w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
            <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
          </svg>
          <span class="flex items-center ml-3">View All Transactions
            @if (pendingCount > 0) {
              <span
              class="ml-2 inline-block min-w-[22px] px-2 py-0.5 text-xs font-semibold text-white bg-red-600 rounded-full align-middle"
            >
              {{ pendingCount }}
            </span>
            }
          </span>
        </a>
      </li>
  </ul>
</div>
</aside>